import React from "react";
import {render, unmountComponentAtNode} from "react-dom";
import {bindable, bindingMode, customElement, inject, noView} from "aurelia-framework";
import {Provider} from "react-redux";
import store from "../store/store";
import OriginForm from "./origin/form";

@noView
@inject(Element)
@customElement("cost-assignment")
export class CostAssignment {

    @bindable({defaultBindingMode: bindingMode.oneTime}) realCostsOrigin;

    constructor(container) {
        this.container = container;
    }

    attached() {
        const origin = this.realCostsOrigin?.id ? {
            id: this.realCostsOrigin.id,
            modelId: this.realCostsOrigin.modelId
        } : undefined

        const creditor = this.realCostsOrigin?.creditor?.id ? {
            id: this.realCostsOrigin.creditor.id,
            modelId: this.realCostsOrigin.creditor.modelId,
        } : undefined

        render(
            <Provider store={store}>
                <OriginForm origin={origin} creditor={creditor}/>
            </Provider>,
            this.container
        );
    }

    detached() {
        unmountComponentAtNode(this.container);
    }
}
